import React, { useState } from 'react';
import './FeedbackForm.css';

function FeedbackForm({ onSubmit, onCancel, loading }) {
  const [feedback, setFeedback] = useState('');
  const [userBought, setUserBought] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!feedback) {
      alert('Please select your feedback');
      return;
    }

    onSubmit({
      user_feedback: feedback,
      user_bought: userBought
    });
  };

  return (
    <div className="feedback-form">
      <div className="card">
        <h2>👍 Your Feedback Matters</h2>
        <p className="feedback-subtitle">
          Help us improve our affordability assessment by sharing whether this recommendation was accurate.
        </p>

        <form onSubmit={handleSubmit}>
          {/* Feedback Options */}
          <div className="feedback-section">
            <h3>Do you agree with this assessment?</h3>

            <div className="feedback-options">
              <label className={`feedback-option ${feedback === 'agree' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="feedback"
                  value="agree"
                  checked={feedback === 'agree'}
                  onChange={(e) => setFeedback(e.target.value)}
                />
                <span className="feedback-label">
                  ✅ Yes, I agree with this assessment
                </span>
              </label>

              <label className={`feedback-option ${feedback === 'disagree' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="feedback"
                  value="disagree"
                  checked={feedback === 'disagree'}
                  onChange={(e) => setFeedback(e.target.value)}
                />
                <span className="feedback-label">
                  ❌ No, I disagree with this assessment
                </span>
              </label>

              <label className={`feedback-option ${feedback === 'unsure' ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="feedback"
                  value="unsure"
                  checked={feedback === 'unsure'}
                  onChange={(e) => setFeedback(e.target.value)}
                />
                <span className="feedback-label">
                  ❓ I'm not sure / Neutral
                </span>
              </label>
            </div>
          </div>

          {/* Purchase Status (Optional) */}
          <div className="feedback-section">
            <h3>Did you make this purchase? (optional)</h3>

            <div className="purchase-options">
              <label className={`purchase-option ${userBought === true ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="purchased"
                  value="yes"
                  checked={userBought === true}
                  onChange={() => setUserBought(true)}
                />
                <span className="purchase-label">
                  ✓ Yes, I made the purchase
                </span>
              </label>

              <label className={`purchase-option ${userBought === false ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="purchased"
                  value="no"
                  checked={userBought === false}
                  onChange={() => setUserBought(false)}
                />
                <span className="purchase-label">
                  ✗ No, I didn't buy it
                </span>
              </label>

              <label className={`purchase-option ${userBought === null ? 'selected' : ''}`}>
                <input
                  type="radio"
                  name="purchased"
                  value="skip"
                  checked={userBought === null}
                  onChange={() => setUserBought(null)}
                />
                <span className="purchase-label">
                  ~ Still deciding
                </span>
              </label>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="feedback-actions">
            <button
              type="submit"
              disabled={loading || !feedback}
              className="submit-btn"
            >
              {loading ? 'Submitting...' : '📤 Submit Feedback'}
            </button>

            <button
              type="button"
              onClick={onCancel}
              disabled={loading}
              className="cancel-btn"
            >
              Cancel
            </button>
          </div>

          <p className="feedback-note">
            Your feedback helps us improve our scoring rules and better serve users like you.
          </p>
        </form>
      </div>
    </div>
  );
}

export default FeedbackForm;
